export default __webpack_public_path__ + "static/media/fire2.322cdcd7.jpeg";